import uuidv4 from './uuidv4';
export function createObjectUidMemory() {
  const isObj = x => (typeof x === 'object' || typeof x === 'function') && !!x;
  const map = new Map();
  const get = obj => {
    if (!isObj(obj)) return '';
    let id = map.get(obj);
    if (!id) {
      id = uuidv4();
      map.set(obj, id);
    }
    return String(id);
  };
  const forget = obj => {
    if (isObj(obj)) return map.delete(obj);
  };
  return {
    get,
    forget
  };
}
export const globalObjectUidMemory = createObjectUidMemory();
export const getObjectUid = globalObjectUidMemory.get;